var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 17,
    viewBox: "0 0 18 17",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.04894.927049c.29936-.92131098 1.60276-.92130883 1.90212.000002l1.29404 3.982779c.1339.41202.5179.69098.9511.69098h4.1877c.9688 0 1.3715 1.23962.5878 1.80902l-3.3879 2.46149c-.3505.25468-.4972.70598-.3633 1.11808l1.2941 3.9827c.2993.9213-.7551 1.6875-1.5389 1.1181l-3.38792-2.4615c-.35048-.2547-.82508-.2547-1.17557 0l-3.38795 2.4615c-.78372.5694-1.83819-.1968-1.53884-1.1181l1.29408-3.9827c.13388-.4121-.01278-.8634-.36327-1.11808l-3.38796-2.46149c-.783709-.5694-.380932-1.80902.58779-1.80902h4.18774c.43323 0 .81719-.27896.95106-.69098z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.309a7aed51b42786f1e943f038db1994.svg";
export { ForwardRef as ReactComponent };